import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Specialty from '@solvhealth/types/interfaces/Specialty';
import { apiGetDispatchable } from '../../../core/dapi';
import { receiveSpecialties, receiveSpecialtiesError } from '../../../ducks/providerGroups';
import { getSpecialtiesUrl } from '../../../core/dapi/specialties';

const useFetchSpecialty = (specialtyName?: string): Specialty => {
  const dispatch = useDispatch();
  const specialty = useSelector(
    (state: any): Specialty => specialtyName && state.providerGroups.specialties?.[specialtyName]
  );

  useEffect(() => {
    if (!specialty) {
      dispatch(
        apiGetDispatchable(getSpecialtiesUrl(), receiveSpecialties, receiveSpecialtiesError)
      );
    }
  }, [dispatch, specialtyName, specialty]);

  return specialty;
};

export default useFetchSpecialty;
